import P5 from "p5";

export default abstract class GeometricOperations {
    public static triNormal(A: P5.Vector, B: P5.Vector, C: P5.Vector): P5.Vector {
        const v1 = new P5.Vector(B.x-A.x, B.y-A.y, B.z-A.z);
        const v2 = new P5.Vector(C.x-A.x, C.y-A.y, C.z-A.z);
        const normal = v2.cross(v1);
        normal.normalize();
        return normal;
    }

    public static midVector(A: P5.Vector, B: P5.Vector): P5.Vector {
        return new P5.Vector((A.x + B.x)/2, (A.y + B.y)/2, (A.z + B.z)/2);
    }
}